var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainbox"},[_c('div',[_c('img',{attrs:{"src":require("../../assets/v4Success.png"),"alt":""}}),_c('p',[_vm._v("报告生成中，请稍候…")]),(_vm.$route.query && _vm.$route.query.redirect_uri)?_c('el-button',{on:{"click":_vm.goback}},[_vm._v("返回")]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }